import React from "react";

const priorityStyle = {
  high: "bg-red-100 text-red-700",
  medium: "bg-amber-100 text-amber-700",
  low: "bg-gray-100 text-gray-600",
};

export const ScoreBadge = ({ score }) => (
  <div className={`inline-grid place-items-center w-12 h-12 rounded-xl font-bold text-[16px] ${score >= 80 ? "bg-[#b8935f] text-white" : score >= 65 ? "bg-[#e7d9c3] text-[#7a5c2e]" : "bg-[#f0ece5] text-[#8a8a8a]"}`} data-testid="score-badge">
    {score}
  </div>
);

export const ProbPill = ({ label, value }) => (
  <span className="inline-flex items-center gap-1.5 text-[12px] text-[#4a4a4a]">
    <span className="font-semibold text-[#2b2b2b]">{Math.round((value || 0) * 100)}%</span> {label}
  </span>
);

export const PriorityTag = ({ priority }) => (
  <span className={`text-[11px] px-2 py-0.5 rounded-full capitalize ${priorityStyle[priority] || priorityStyle.low}`}>{priority}</span>
);

export const money = (n) => (n || n === 0 ? `£${Number(n).toLocaleString()}` : "—");
